/// <reference path="../_references.ts"/>

module App.Utils {
	angular.module('utils', [])
		.directive('slideOut', ['$timeout', SlideOutDirective.Factory()])
		.factory('ToastService', [ToastService.Factory()])
		.factory('DefaultToasts', [DefaultToasts.Factory()])
		.factory('OfficeService', ['$rootScope','$location', 'AppointmentService', 'SelectedAppointment', 'UserSession', '$q', OfficeService.Factory()])
		.factory('OrganizationService', OrganizationService.Factory());
}